export class LoginError implements Error {
  public stack?: string;

  constructor(
    public message: string,
    public readonly name = 'LoginError',
    public readonly triesLeft?: number,
    public loginLockedUntil?: string,
    public mailSent?: boolean,
  ) {}

  public get error(): string {
    return this.message;
  }
}

export class LoginWithPasswordError extends LoginError {
  public error_description?: string;

  constructor(
    message: string,
    triesLeft?: number,
    loginLockedUntil?: string,
    errorDescription?: string,
    mailSent?: boolean,
  ) {
    super(message, 'LoginWithPasswordError', triesLeft, loginLockedUntil, mailSent);
    this.error_description = errorDescription;
  }
}

export type FailedLoginInfo = {
  error: string;
  triesLeft?: number;
  loginLockedUntil?: Date;
  mailSent?: boolean;
};
